import { render } from "./TransactionPage.vue?vue&type=template&id=407dc28e&scoped=true"
import script from "./TransactionPage.vue?vue&type=script&lang=js"
export * from "./TransactionPage.vue?vue&type=script&lang=js"

import "./TransactionPage.vue?vue&type=style&index=0&id=407dc28e&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-407dc28e"]])

export default __exports__